import { render, staticRenderFns } from "./SubscriptionAlert.vue?vue&type=template&id=28da0ea9&scoped=true"
import script from "./SubscriptionAlert.vue?vue&type=script&lang=js"
export * from "./SubscriptionAlert.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionAlert.vue?vue&type=style&index=0&id=28da0ea9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28da0ea9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28da0ea9')) {
      api.createRecord('28da0ea9', component.options)
    } else {
      api.reload('28da0ea9', component.options)
    }
    module.hot.accept("./SubscriptionAlert.vue?vue&type=template&id=28da0ea9&scoped=true", function () {
      api.rerender('28da0ea9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/Components/SubscriptionAlert.vue"
export default component.exports